// Following the theme best practices, here are customizations for Ocu-GLO

document.addEventListener("DOMContentLoaded", function () {
  function superscriptRegisteredTrademark(node) {
    if (node.nodeType === 3) {
      // Text node
      var replacedText = node.nodeValue.replace(/Ocu\-GLO®/g, function (match) {
        return '<span class="no-break">Ocu-GLO<sup>®</sup></span>';
      });

      if (replacedText !== node.nodeValue) {
        var span = document.createElement("span");
        span.innerHTML = replacedText;
        node.parentNode.replaceChild(span, node);
      }
    } else {
      node.childNodes.forEach(function (child) {
        superscriptRegisteredTrademark(child);
      });
    }
  }

  superscriptRegisteredTrademark(document.body);
});
